import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { SMS_CONSENT_COOKIE } from '../../consts';

export const useSmsConsentState = () => {
  const [smsConsent, setSmsConsent] = useState(false);
  const [isPhoneError, setPhoneError] = useState(false);

  useEffect(() => {
    const savedConsent = Cookies.get(SMS_CONSENT_COOKIE);

    if (savedConsent) {
      const smsConsent = savedConsent === 'true';

      setSmsConsent(smsConsent);

      if (smsConsent) {
        setPhoneError(true);
      }
    }
  }, []);

  return { smsConsent, isPhoneError, setSmsConsent, setPhoneError };
};
